/**
 * Meta Pixel — essentiële retargeting-/funnel-events (na marketing-consent).
 * PageView: theme.liquid
 * Hier: ViewContent, ViewCategory, Search, AddToCart, AddToWishlist,
 *        InitiateCheckout, Lead
 * Purchase: Shopify Meta-app (CAPI) + optioneel Customer Events pixel
 */
(function () {
  'use strict';

  var currencyFallback =
    (window.UF_META_PIXEL && window.UF_META_PIXEL.currency) ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    'EUR';

  function marketingAllowed() {
    try {
      var raw = localStorage.getItem('uf_cookie_consent_v2');
      if (!raw) return false;
      var data = JSON.parse(raw);
      return !!(data && data.marketing);
    } catch (e) {
      return false;
    }
  }

  function whenFbqReady(cb) {
    var tries = 0;
    (function tick() {
      if (typeof window.fbq === 'function') {
        cb();
        return;
      }
      if (tries++ > 40) return;
      setTimeout(tick, 100);
    })();
  }

  function track(eventName, params, custom) {
    if (!marketingAllowed()) return;
    whenFbqReady(function () {
      try {
        window.fbq('consent', 'grant');
        if (custom) {
          window.fbq('trackCustom', eventName, params || {});
        } else {
          window.fbq('track', eventName, params || {});
        }
      } catch (e) {}
    });
  }

  function moneyFromCents(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return 0;
    return Math.round(n) / 100;
  }

  function activeCurrency(cart) {
    return (
      (cart && cart.currency) ||
      currencyFallback
    );
  }

  function trackAddToCart(item) {
    if (!item) return;
    var id = item.variant_id || item.id;
    var qty = item.quantity || 1;
    var line =
      item.line_price != null
        ? item.line_price
        : item.price != null
          ? item.price * qty
          : 0;

    track('AddToCart', {
      content_ids: id != null ? [String(id)] : [],
      content_name: item.product_title || item.title || undefined,
      content_type: 'product',
      contents: id != null ? [{ id: String(id), quantity: qty }] : undefined,
      value: moneyFromCents(line),
      currency: activeCurrency()
    });
  }

  function trackViewContent() {
    var p = window.UF_META_PRODUCT;
    if (!p || !p.variantId) return;
    track('ViewContent', {
      content_ids: [String(p.variantId)],
      content_name: p.name || undefined,
      content_type: 'product',
      content_category: p.category || undefined,
      value: p.price != null ? Number(p.price) : undefined,
      currency: p.currency || currencyFallback
    });
  }

  function trackViewCategory() {
    var c = window.UF_META_COLLECTION;
    if (!c || !c.name) return;
    track(
      'ViewCategory',
      {
        content_name: c.name,
        content_category: c.name,
        content_ids: Array.isArray(c.contentIds) ? c.contentIds.map(String) : [],
        content_type: 'product'
      },
      true
    );
  }

  function trackSearch() {
    var s = window.UF_META_SEARCH;
    if (!s || !s.query) return;
    track('Search', {
      search_string: String(s.query),
      content_ids: Array.isArray(s.contentIds) ? s.contentIds.map(String) : undefined,
      content_type: 'product'
    });
  }

  function trackInitiateCheckoutFromCart(cart) {
    var items = (cart && cart.items) || [];
    var contents = items.map(function (item) {
      return {
        id: String(item.variant_id),
        quantity: item.quantity || 1,
        item_price: moneyFromCents(item.price)
      };
    });
    track('InitiateCheckout', {
      content_ids: contents.map(function (row) {
        return row.id;
      }),
      contents: contents,
      content_type: 'product',
      value: moneyFromCents(cart && cart.total_price),
      currency: activeCurrency(cart),
      num_items: (cart && cart.item_count) || contents.length
    });
  }

  function trackInitiateCheckout() {
    if (typeof window.fetch !== 'function') {
      track('InitiateCheckout');
      return;
    }
    window
      .fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (cart) trackInitiateCheckoutFromCart(cart);
        else track('InitiateCheckout');
      })
      .catch(function () {
        track('InitiateCheckout');
      });
  }

  function trackLead() {
    track('Lead');
  }

  function trackAddToWishlist(payload) {
    var ids = [];
    if (payload && payload.variantId) ids.push(String(payload.variantId));
    else if (payload && payload.productId) ids.push(String(payload.productId));
    track('AddToWishlist', {
      content_ids: ids,
      content_name: payload && payload.name ? payload.name : undefined,
      content_type: 'product',
      value: payload && payload.price != null ? Number(payload.price) : undefined,
      currency: (payload && payload.currency) || currencyFallback
    });
  }

  function bindAjaxAddToCart() {
    if (!window.jQuery) return;
    window.jQuery(document).ajaxSuccess(function (_event, xhr, settings) {
      try {
        var url = (settings && settings.url) || '';
        if (url.indexOf('/cart/add') === -1) return;
        var data = xhr.responseJSON;
        if (!data && xhr.responseText) data = JSON.parse(xhr.responseText);
        trackAddToCart(data);
      } catch (e) {}
    });
  }

  function bindFetchAddToCart() {
    if (typeof window.fetch !== 'function' || window.__ufMetaFetchPatched) return;
    window.__ufMetaFetchPatched = true;
    var orig = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === 'string' ? input : input && input.url ? input.url : '';
      return orig.apply(this, args).then(function (res) {
        if (url && String(url).indexOf('/cart/add') !== -1 && res && res.ok) {
          try {
            res
              .clone()
              .json()
              .then(trackAddToCart)
              .catch(function () {});
          } catch (e) {}
        }
        return res;
      });
    };
  }

  function bindCheckoutClicks() {
    document.addEventListener(
      'click',
      function (e) {
        var el =
          e.target && e.target.closest
            ? e.target.closest(
                'a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [href="/checkout"], [name="goto_fp"]'
              )
            : null;
        if (!el) return;
        trackInitiateCheckout();
      },
      true
    );
  }

  function bindWishlist() {
    document.addEventListener(
      'click',
      function (e) {
        var btn =
          e.target && e.target.closest
            ? e.target.closest('[data-uf-lf-wishlist], .uf-lf-wishlist, button.wishlist, .wishlist-btn')
            : null;
        if (!btn) return;

        // Alleen tracken bij toevoegen (niet bij verwijderen)
        var willAdd = !btn.classList.contains('is-active') && btn.getAttribute('aria-pressed') !== 'true';
        if (!willAdd) return;

        var productId = btn.getAttribute('data-product-id') || btn.getAttribute('data-id');
        var variantId = btn.getAttribute('data-variant-id');
        var name = btn.getAttribute('data-product-title') || btn.getAttribute('data-title');
        var price = btn.getAttribute('data-product-price') || btn.getAttribute('data-price');

        if (!variantId && window.UF_META_PRODUCT && window.UF_META_PRODUCT.variantId) {
          variantId = window.UF_META_PRODUCT.variantId;
          name = name || window.UF_META_PRODUCT.name;
          price = price != null ? price : window.UF_META_PRODUCT.price;
        }

        trackAddToWishlist({
          productId: productId,
          variantId: variantId,
          name: name,
          price: price != null && price !== '' ? Number(price) : undefined
        });
      },
      true
    );
  }

  function isContactForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/contact') !== -1) return true;
    if (form.id === 'contact_form' || form.id === 'ContactForm') return true;
    if (form.getAttribute('accept-charset') && form.querySelector('[name="form_type"][value="contact"]')) {
      return true;
    }
    if (form.querySelector('input[name="form_type"][value="contact"]')) return true;
    // Aanvraag speciale vloer e.d.
    if (form.classList.contains('uf-asfr-form') || form.getAttribute('data-uf-lead-form') === 'true') {
      return true;
    }
    return false;
  }

  function bindLeadForms() {
    document.addEventListener(
      'submit',
      function (e) {
        if (isContactForm(e.target)) trackLead();
      },
      true
    );
  }

  function initPageEvents() {
    trackViewContent();
    trackViewCategory();
    trackSearch();
  }

  function init() {
    bindAjaxAddToCart();
    bindFetchAddToCart();
    bindCheckoutClicks();
    bindWishlist();
    bindLeadForms();
    initPageEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('uf:cookie-consent', function (e) {
    if (e && e.detail && e.detail.marketing) {
      initPageEvents();
    }
  });
})();
